import { useMatch } from 'react-router-dom';

export const useIsVideoPreviewOpen = () => {
  const visPreviewMatch = useMatch('/:locale/:entity/:entityId/vis/preview');
  const dataLockerVideoPreviewMatch = useMatch('/:locale/data-locker/events/video/preview');

  return !!visPreviewMatch || !!dataLockerVideoPreviewMatch;
};
